import { WriterSalesGraphTypeEnum } from '@interfaces/WriterSalesGraphTypeEnum'
import { Expose, Type } from 'class-transformer'
import { SalesAnalyticsDataTableType } from './SalesAnalyticsDataTableType'
import { SalesAnalyticsGraphDataType } from './SalesAnalyticsGraphDataType'

export class WriterSalesAnalyticsDetailDataType {
  @Expose()
  @Type(() => SalesAnalyticsDataTableType)
  tableData: SalesAnalyticsDataTableType[]

  @Expose()
  @Type(() => SalesAnalyticsGraphDataType)
  graphData: SalesAnalyticsGraphDataType[]

  @Expose()
  graphType: WriterSalesGraphTypeEnum
}
